import * as Yup from "yup";
import SessionManager from "./Session";
import { toast } from "react-toastify";
export const InputType = {
  email: "email",
  password: "password",
  text: "text",
  number: "number",
  date: "date",
  file: "file",
};

export const handleApiErrors = (error) => {
  const statusCode = error?.response?.status;
  if (statusCode) {
    switch (statusCode) {
      case 401:
        SessionManager.shared.logout();
        break;
      case 400:
        toast.error(error?.response?.data?.error);
        break;
      default:
        break;
    }
  }
};

const generatePasswordValidation = () => {
  return Yup.string()
    .trim()
    .required("Field can't be empty!")
    .min(6, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]+$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
    );
};

export const getTextFromHtml = (html) => {
  return html?.replace(/<[^>]+>/g, "");
};

export const validationRegex = {
  email: Yup.string()
    .trim()
    .required("Email is required  ")
    .email("Invalid email")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email format"),
  password: generatePasswordValidation(),
  currentPassword: generatePasswordValidation(),
  newPassword: generatePasswordValidation(),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
  mobile: Yup.string()
    .trim()
    .required("Field can't be empty!")
    .matches(/^[6-9]\d{9}$/, "Entered Mobile Number is Invalid!"),
  dob: Yup
    .string()
    .required("Field can't be empty!")
    .test('DOB', 'Cannot select future date!', value => {
      return new Date(value).getTime() < new Date().getTime();
    }),
  required: Yup.string().trim().required("Field can't be empty!"),
  date: (date) =>
    Yup.date()
      .trim()
      .required("Field can't be empty!")
      .min(date, "Class End Date must be in the future"),
  facebookLink: Yup.string()
    .trim()
    .required("Facebook link is required")
    .matches(
      /^https:\/\/www\.facebook\.com(\/[A-Za-z0-9._-]+\/?)?$/,
      "Invalid Facebook link"
    ),
  instagramLink: Yup.string()
    .trim()
    .required("Instagram link is required")
    .matches(
      /^https:\/\/www\.instagram\.com\/([A-Za-z0-9._-]+\/?)?$/,
      "Invalid Instagram link"
    ),
  linkedInLink: Yup.string()
    .trim()
    .required("LinkedIn link is required")
    .matches(
      /^https:\/\/(www\.|[a-z]{2}\.)?linkedin\.com\/(in\/[A-Za-z0-9._-]+|company\/[A-Za-z0-9._-]+|school\/[A-Za-z0-9._-]+|)?$/,
      "Invalid LinkedIn link"
    ),


  youtubeLink: Yup.string()
    .trim()
    .required("YouTube link is required")
    .matches(
      /^(https:\/\/(www\.)?(youtube\.com\/(watch\?v=[A-Za-z0-9._-]+(&[^\s]*)?|embed\/|v\/|.+\?v=|$)|youtu\.be\/[A-Za-z0-9._-]+)(\S*)?)$/,
      "Invalid YouTube link"
    ),
  twitterLink: Yup.string()
    .trim()
    .required("Twitter link is required")
    .matches(
      /^(https:\/\/(www\.)?(x\.com\/(i\/web|[A-Za-z0-9_]+\/?)|x\.com\/\?lang=en)?)$/,
      "Invalid Twitter link"
    ),
  sliderOneLink: Yup.string()
    .trim()
    .required("URL is required")
    .matches(
      /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[a-z\d_]*)?$/i,
      "Invalid URL"
    ),
  sliderTwoLink: Yup.string()
    .trim()
    .required("URL is required")
    .matches(
      /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[a-z\d_]*)?$/i,
      "Invalid URL"
    ),
  sliderThreeLink: Yup.string()
    .trim()
    .required("URL is required")
    .matches(
      /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[a-z\d_]*)?$/i,
      "Invalid URL"
    )
  // file: Yup.mixed()
  // .required('File is required')
  // .test(
  //   'fileSize',
  //   'File size must be less than 20kb',
  //   (value) => value && value.size <= 20000
  // )

};

export class ValidationHelper {
  static isValidUrl(urlString) {
    var urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // validate fragment locator
    return !!urlPattern.test(urlString);
  }

  static isValidYoutubeUrl(urlString) {
    var urlPattern =
      /^(?:(?:https?:)?\/\/)?(?:(?:(?:www|m(?:usic)?)\.)?youtu(?:\.be|be\.com)\/(?:shorts\/|live\/|v\/|e(?:mbed)?\/|watch(?:\/|\?(?:\S+=\S+&)*v=)|oembed\?url=https?%3A\/\/(?:www|m(?:usic)?)\.youtube\.com\/watch\?(?:\S+=\S+&)*v%3D|attribution_link\?(?:\S+=\S+&)*u=(?:\/|%2F)watch(?:\?|%3F)v(?:=|%3D))?|www\.youtube-nocookie\.com\/embed\/|www\.youtube\.com\/(?:laylists(?:\?|\/list=)|watch\?.*&list=))([\w-]{11})[\?&#]?\S*$/i;
    // validate fragment locator
    return !!urlPattern.test(urlString);
  }

  static formatBytes(bytes, decimals = 2) {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
}
